export default class DefinitionTable {
  public code = "";
  public label = "";
}
